var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"rowbg"},[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',[_c('b-card-title',[_vm._v("In koor zingen wij")]),_c('b-card-text',[_c('silent-box',{staticClass:"galleryitems",attrs:{"gallery":_vm.galleryvideos}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }